import React from "react";
// todo pasar por parametro funcion onChange para cada input.
const Register = ({ register, errors }) => {
  return (
    <>
      <div className="grid grid-cols-2 gap-2">
        <div className="w-full">
          <input
            type="text"
            className={`${errors.name ? 'bg-red-200 placeholder:text-red-600' : 'bg-custom-azul-claro placeholder:text-custom-azul-medio'}  w-full text-[#037EF3] text-sm p-2 px-6 rounded-xl outline-none focus:outline-[#037EF3] focus:bg-white outline-offset-0 outline-1`}
            placeholder="Tu nombre"
            {...register("name", { required: true })}
            // onChange={(e) => setName(e.target.value)}
          />
          {errors.name && <i className="text-xs ml-3 text-red-600">*Espacio obligatorio</i>}
        </div>
        <div className="w-full">
          <input
            type="text"
            className={`${errors.lastName ? 'bg-red-200 placeholder:text-red-600' : 'bg-custom-azul-claro placeholder:text-custom-azul-medio'}  w-full text-[#037EF3] text-sm p-2 px-6 rounded-xl outline-none focus:outline-[#037EF3] focus:bg-white outline-offset-0 outline-1`}
            placeholder="Apellidos"
            {...register("lastName", { required: true })}
          />
          {errors.lastName && <i className="text-xs ml-3 text-red-600">*Espacio obligatorio</i>}
        </div>
        <input
          type="text"
          className={`${errors.email ? 'bg-red-200 placeholder:text-red-600' : 'bg-custom-azul-claro  placeholder:text-custom-azul-medio'}  text-[#037EF3] text-sm p-2 px-6 rounded-xl outline-none focus:outline-[#037EF3] focus:bg-white outline-offset-0 outline-1 col-span-2`}
          placeholder="Correo electrónico"
          {...register("email", { required: "*Espacio obligatorio", pattern:{value:/^\w+([.-_+]?\w+)@\w+([.-]?\w+)(\.\w{2,10})+$/, message:"*Este correo no es valido"} })}
          
        />
        {errors.email && (
          <i className="text-xs ml-3 text-red-600">
            {errors.email.message}
          </i>
        )}
        <div className="col-span-2">
          <input
            type="password"
            className= {`${errors.pass ? 'bg-red-200 placeholder:text-red-600' : 'bg-custom-azul-claro  placeholder:text-custom-azul-medio'}  text-[#037EF3] text-sm p-2 px-6 rounded-xl outline-none focus:outline-[#037EF3] focus:bg-white outline-offset-0 outline-1 w-full`}
            placeholder="Password"
            {...register("pass", { required: "*Espacio obligatorio", minLength: { value:8 , message:"*Debe tener minimo 8 caracteres" }, validate: { isUpper: (value)=> /.*[A-Z].*/.test(value), isLower: (value)=> /.*[a-z].*/.test(value), isNumber: (value)=> /.*[0-9].*/.test(value)}})}
          />
          {errors.pass && errors.pass.type==="required" && <i className="text-xs ml-3 text-red-600">*Espacio obligatorio</i>}
          {errors.pass && errors.pass.type==="isUpper" && <i className="text-xs ml-3 text-red-600">*Debe tener minimo una mayuscula</i>}
          {errors.pass && errors.pass.type==="isLower" && <i className="text-xs ml-3 text-red-600">*Debe tener minimo una minuscula</i>}
          {errors.pass && errors.pass.type==="isNumber" && <i className="text-xs ml-3 text-red-600">*Debe tener minimo un numero</i>}
          {errors.pass && errors.pass.type==="minLength" && <i className="text-xs ml-3 text-red-600">*Debe tener minimo 8 caracteres</i>}
          {console.log(errors.pass)}
        </div>
        {/*<div className="col-span-2 grid grid-cols-4 gap-1">
          <div className="h-[5px] bg-[#037EF3] rounded-full"></div>
          <div className="h-[5px] bg-[#CDE5FD] rounded-full"></div>
          <div className="h-[5px] bg-[#CDE5FD] rounded-full"></div>
          <div className="h-[5px] bg-[#CDE5FD] rounded-full"></div>
        </div>*/}
      </div>
      
      <a
        className="text-xs text-gray-400 font-bold pl-3"
        href="https://auth.aiesec.org/users/password/new"
      >
        ¿Olvidaste tu contraseña?
      </a>
    </>
  );
};

export default Register;
